import React from 'react';
import { Modal } from 'antd';
import './styles.scss';
import { useIntl } from 'react-intl';

const MyModalV2 = ({ footerNull = true, ...rest }) => {
  const intl = useIntl();
  return (
    <Modal
      centered
      className={`my-modal-v2 ${rest.classNameModal}`}
      destroyOnClose
      onCancel={rest.onClose}
      keyboard={false}
      maskClosable={false}
      {...(footerNull ? { footer: null } : {})}
      okButtonProps={{
        className: 'ant-btn site-button btn-primary-custom w-175 h-45',
      }}
      cancelButtonProps={{
        className:
          'ant-btn site-button btn-secondary-outline primary-color w-175 h-45',
      }}
      cancelText={intl.formatMessage({ id: 'common.cancel' })}
      {...rest}
    >
      <div className="my-modal-wrapper">
        <div className="my-modal-body">{rest.children}</div>
      </div>
    </Modal>
  );
};

export default MyModalV2;
